import React, { Component, PureComponent } from 'react'

export default function Logo() {
  return (
    <img
      src="https://d2nce6johdc51d.cloudfront.net/img/kokemuksia-logo.png"
      alt="kokemuksia.fi"
      className="main-logo"
    />
  )
}
